<template src="./html/animal-quiz.html"></template>

<script>
import App from '../App.vue'
import { quizFunctions } from "../components/functions";
import globalMixin from '../mixins/global';

let quiz = {
    questions: [{
      text: "My favorite part about the learning process is...",
      responses: [{
          text: 'Diving into the data to uncover hidden gems of insight',
          value: '1'
        },
        {
          text: 'Watching people spark ideas and learn together',
          value: '0'
        },
        {
          text: 'Playing with the latest, coolest gadgets and tools',
          value: '2'
        },
        {
          text: 'Crafting mind-blowing content and epic experiences',
          value: '3'
        }
      ],
      image: '',
    },
    {
      text: "My ideal meal would be...",
      responses: [{
          text: 'A seafood smorgasbord straight from the ocean ',
          value: '0'
        },
        {
          text: 'A juicy, charbroiled burger grilled to perfection',
          value: '1'
        },
        {
          text: 'A refreshing salad bursting with green goodness ',
          value: '2,3'
        }
      ],
      image: ''      
    },
    {
      text: "I do my best learning...",
      responses: [{
          text: 'Flying solo and mastering the art of self-discovery',
          value: '1,3'
        },
        {
          text: 'Teaming up with others to create a powerhouse of knowledge',
          value: '0'
        },
        {
          text: 'Mixing it up with a bit of solo exploration and group collaboration',
          value: '2'
        }
      ],
      image: ''    
    },
    {
    text: "Having crossed Ontario off my list, the area of Canada I’d most like to visit is...",
      responses: [{
          text: 'The picturesque waterways and coasts of Quebec and Atlantic provinces',
          value: '3'
        },
        {
          text: 'The wide-open, golden prairies that stretch to the horizon',
          value: '2'
        },
        {
          text: 'The extraordinary Northern territories and rugged arctic coastline',
          value: '0'
        },
        {
          text: 'The breathtaking West Coast and the mountains that tower above it',
          value: '1'
        }
      ],
      image: ''    
    },
    {
      text: "I prefer when learning...",
      responses: [{
          text: 'Follows a clear, well-lit path',
          value: '0,2'
        },
        {
          text: 'Lets me blaze my own trail',
          value: '1,3'
        }
      ],
      image: '' 
    },
    {
    text: "The quote that resonates with me the most is...",
      responses: [{
          text: 'A great song\'s greatest attribute is how it hints at more. <br />- Gord Downie, musician',
          value: '0'
        },
        {
          text: 'You have to ask yourself, Am I building a birdhouse or a deck? Measure twice, cut once. <br />- Alistair MacLeod, novelist',
          value: '1'
        },
        {
          text: 'My old mentor once told me: if you find yourself too comfortable, move. <br />- Victor Garber, actor',
          value: '2'
        },
        {
          text: 'Pay attention to yourself. Build on who you are. Become a whole person. Enjoy life. <br />- Andrea Bain, TV host and author',
          value: '3'
        }
      ],
      image: ''
    }
  ]
};

let types_content = {

    sections: [
      {
        section_title: 'Beluga',
        hovered_content: 'Embracing remote learning early',
        background_colour: 'color-cinnabar-p1',
        text_colour: 'color-onyx',
        image: require('../assets/learner-quiz-Beluga.png'),
        social_description: 'I\'m a Beluga! Register for Fusion to find out what superhero you are!',
        winner_content: '<p>You\'re the champion of the community, always keeping a pulse on the group and making sure everyone has what they need to thrive. After all, we can go far alone, but we\'ll go farther together. </p> <p><strong>Strengths:</strong> Empathizing with people to help advocate for the group </p> <p><strong>Motivators:</strong> Community and collaboration</p> <p><strong>Top Tools:</strong> Discussions, Video Assignment, Virtual Classroom, Portfolio, Awards Leaderboard</p>',
        download_pdf: ''
      },
      {
        section_title: 'Cougar',
        hovered_content: 'Knowing how to use the latest tools',
        background_colour: 'color-fluorite',
        text_colour: 'd2lWhite',
        image: require('../assets/learner-quiz-Cougar.png'),
        social_description: 'I\'m a Cougar! Register for Fusion to find out what superhero you are!',
        winner_content: '<p>You\'re the ultimate surveyor of your surroundings. With a keen understanding of what’s going on around you, you thrive on data and analytics. Success is your middle name, and you find fulfillment in knowing the ins and outs of everything.</p> <p><strong>Strengths:</strong> Understanding what\'s working and what\'s not</p> <p><strong>Motivators:</strong> Data and analytics</p> <p><strong>Top Tools:</strong> Achievement+, Insights Dashboard, Outcome Achievement Dashboard, Mastery View</p>',
        download_pdf: ''
      },
      {
        section_title: 'Monarch Butterfly',
        hovered_content: 'Finding the fastest ways to do things',
        background_colour: 'color-citrine',
        text_colour: 'color-onyx',
        image: require('../assets/learner-quiz-Monarch Butterfly.png'),
        social_description: 'I\'m a Monarch Butterfly! Register for Fusion to find out what superhero you are!',
        winner_content: '<p>Change doesn\'t scare you; you embrace it. Your keen understanding of trends and your love for innovation keeps you ahead of the curve. Transformation might be uncomfortable, but you know it\'s the only way to grow and stretch your wings.</p> <p><strong>Strength:</strong> Understanding trends and encouraging innovation</p> <p><strong>Motivator:</strong> Innovation and change</p> <p><strong>Top Tools:</strong> Practice Questions (AI Beta Program), Quiz Questions (AI Beta Program), AI Coach, Intelligent Agents, Course Merchant</p>',
        download_pdf: ''
      },
      {
        section_title: 'Beaver',
        hovered_content: 'Having an in-depth knowledge of what’s going on',
        background_colour: 'color-malachite',
        text_colour: 'color-onyx',
        image: require('../assets/learner-quiz-Beaver.png'),
        social_description: 'I\'m a Beaver! Register for Fusion to find out what superhero you are!',
        winner_content: '<p>You\'re a creator extraordinaire, shaping the world around you with your amazing creations. Your inventive spirit and creativity drive you to hone your craft constantly. You find joy in perfecting your work and influencing others through your fantastic creations.</p> <p><strong>Strength:</strong> Creating world-class experiences</p> <p><strong>Motivators:</strong> Invention and creativity</p> <p><strong>Top Tools:</strong> Creator+, Insert Stuff, HTML templates, My CPD Tracker </p>',
        download_pdf: ''
      }
    ]
};

export default {
  name: 'fusion-superhero-type-quiz',
  data() { 
    return this.defaultQuizData() 
  },
  mixins: [quizFunctions, globalMixin],
  methods: {
    defaultQuizData: function () {
      return {
        name:'canadian-animal-type',
        title: 'Which animal are you?',
        share_description: 'Complete this quiz to find out which animal you are!',
        active_image_default: '',
        active_image: '',
        active_section: '-1',
        active_colour_default: 'd2lOrange',
        active_colour: 'd2lOrange',
        winning_colour: '',
        winning_text_colour: '',
        winning_image: '',
        winning_title: '',
        winning_attributes: [],
        content_display: '',
        quiz_hidden: false,
        quiz: quiz,
          questionIndex: 0,
          userResponses: Array(),
        homepage_hidden: false,
        types: types_content,
        share_url: 'https://www.d2l.com/fusion/',
        showForm: false,
        form_text: '',
        form_thank_you_message: '',
        hide_form: true,
        button_text: '',
        form_id: '2289',
        salesforce_id: '7015W0000008zKWQAY',
        asset_redirect: ''
      }
    }
  }
}

</script>